import React from 'react'
import moment from 'moment'
import ListItemBase from 'components/list-items/ListItemBase'
import UserAvatar from 'components/UserAvatar'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { UserModel } from 'data/models'
import { ListItemAvatar } from '@material-ui/core'
import { useTheme } from '@material-ui/core'

import Button from 'components/Buttons'
import { WaoMenu } from 'components/Forms'
import { WaoMenuItem } from 'components/Forms.Interfaces'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  user: UserModel
  selected?: boolean
  multiSelect?: boolean
  handleSelect?: (user: UserModel) => void
  primaryText?: (user: UserModel) => string
  secondaryText?: (user: UserModel) => string
  handleDelete?: (user: UserModel) => void
}
const UserListItem: React.FC<Props> = ({ user, selected, handleSelect, primaryText, secondaryText, multiSelect = false, handleDelete }) => {
  const theme = useTheme();
  const intl = useIntl();
  const mod = theme.palette.type === 'dark' ? 'is-dark' : 'is-light';
  const getSecondaryText = (user: UserModel) => {
    if (user.Lastname && user.Firstname) {
      return `${user.Lastname}, ${user.Firstname}`
    }
    if (user.Firstname) {
      return user.Firstname
    }
    if (!user.CreateDate || moment(user.CreateDate).year() < 1900) {
      return '';
    }

    return intl.formatMessage({ id: 'user.createdAgo', defaultMessage: 'Created {time}' }, { time: moment(user.CreateDate).fromNow() });

  }

  const items: WaoMenuItem[] = [];
  if (handleDelete) {
    items.push({
      name: 'delete',
      control: <Button.DeleteButton fullWidth click={() => handleDelete(user)} />
    });
  }

  return (
    <ListItemBase multiSelect={multiSelect} handleClick={() => handleSelect && handleSelect(user)} selected={selected}>
      <ListItem>
        <ListItemAvatar>
          <UserAvatar username={user.Username} photoUrl={user.PhotoURL} />
        </ListItemAvatar>
        <ListItemText
          primary={primaryText?.(user) || user.Username}
          secondary={
            <>
              {secondaryText?.(user) || getSecondaryText(user)}
              {!user.IsActive && (
                <span className={`tag is-upercase is-danger ${mod}`}>
                  {' '}
                  <FormattedMessage id="user.listItem.inactive" defaultMessage="Inactive" />
                </span>
              )}
            </>
          }
        />
        {items.length > 0 && (
          <WaoMenu items={items} />
        )}
      </ListItem>
    </ListItemBase>
  )
}

export default UserListItem